import { render, staticRenderFns } from "./LinksInputs.vue?vue&type=template&id=b04c5f02&scoped=true&"
import script from "./LinksInputs.vue?vue&type=script&lang=js&"
export * from "./LinksInputs.vue?vue&type=script&lang=js&"
import style0 from "./LinksInputs.vue?vue&type=style&index=0&id=b04c5f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04c5f02",
  null
  
)

export default component.exports